import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsOSPara } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";

export default function OurStoryParaView() {
  const {id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return
    };
    const fetchTitle = async () => {
      try {
        const response = await getAboutUsOSPara(id);
      const overStoryData = response.data.data;
        setData(overStoryData)
      } catch (error) {
        console.error(error);
      }finally {
        setIsLoading(false); // Stop spinner
      }
    };
    fetchTitle()
  }, [id]);

  const columns = ["Part Name", "Content"];
  const rows = [];

  if(Array.isArray(data) && data.length > 0) {
    const item = data[0];
    rows.push(["Paragraph 1", item.paragraph1]);
    rows.push(["Paragraph 2", item.paragraph2]);
    rows.push(["Paragraph 3", item.paragraph3]);
  }

  return (
   <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Our Story Paragraph Section</HomeTitle>
      {/* Table */}
      <CustomTable
        columns={columns}
        rows={rows}
        isLoading={isLoading}
      />
      {/* Button section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/our_story_paragraph/edit/${id}`}
        >
          <Button>{Number(id) ? 'Edit' : 'Add'} Our Story Paragraph</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
   </>
  );
}

const ContentWrapper = styled.div`
 @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
